'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _redboxReact2 = require('redbox-react');

var _redboxReact3 = _interopRequireDefault(_redboxReact2);

var _react2 = require('react');

var _react3 = _interopRequireDefault(_react2);

var _reactTransformCatchErrors3 = require('react-transform-catch-errors');

var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);

var _class, _temp;

require('./UserInfoView.less');

var _Slider = require('components/Slider');

var _UserProfile = require('components/UserProfile');

var _components2 = require('components');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _components = {
  UserInfoView: {
    displayName: 'UserInfoView'
  }
};

var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
  filename: '/usr/local/ibonus/src/components/UserProfile/UserInfo/default/UserInfoView.jsx',
  components: _components,
  locals: [],
  imports: [_react3.default, _redboxReact3.default]
});

function _wrapComponent(id) {
  return function (Component) {
    return _reactTransformCatchErrors2(Component, id);
  };
}

var UserInfoView = _wrapComponent('UserInfoView')((_temp = _class = function (_Component) {
  (0, _inherits3.default)(UserInfoView, _Component);

  function UserInfoView(props) {
    (0, _classCallCheck3.default)(this, UserInfoView);
    return (0, _possibleConstructorReturn3.default)(this, (UserInfoView.__proto__ || (0, _getPrototypeOf2.default)(UserInfoView)).call(this, props));
  }

  (0, _createClass3.default)(UserInfoView, [{
    key: 'render',
    value: function render() {
      return _react3.default.createElement(
        'div',
        { className: 'profile' },
        _react3.default.createElement(
          'h2',
          { className: 'title' },
          this.props.lang['store.user_profile_menu.profile']
        ),
        _react3.default.createElement(
          'div',
          { className: 'row' },
          _react3.default.createElement(
            'form',
            { className: 'form-horizontal col-sm-12' },
            _react3.default.createElement(
              'div',
              { className: 'row' },
              this.renderUserBalance(),
              this.renderUserProfileFields(),
              _react3.default.createElement(
                'div',
                { className: 'form-group align-bottom col-sm-12 col-xs-12' },
                _react3.default.createElement(
                  'div',
                  { className: 'row' },
                  _react3.default.createElement(
                    'div',
                    { className: 'col-md-10 col-sm-9 col-sm-offset-3 col-md-offset-2 col-xs-12' },
                    _react3.default.createElement(
                      'a',
                      { className: 'button_more', onClick: this.props.changePassword },
                      this.props.lang['store.password_change.change_password']
                    )
                  )
                )
              )
            )
          )
        )
      );
    }
  }, {
    key: 'renderUserBalance',
    value: function renderUserBalance() {
      var _props = this.props,
          lang = _props.lang,
          currency = _props.currency;

      var AccountsList = this.props.user.amount;

      if (!Array.isArray(AccountsList) || AccountsList.length === 0) {
        return null;
      }

      return _react3.default.createElement(
        'div',
        { className: 'col-xs-12' },
        _react3.default.createElement(
          'div',
          { className: 'amount_wrap' },
          _react3.default.createElement(
            'p',
            { className: 'balans_title' },
            lang['store.user_info.balance'],
            ':'
          ),
          _react3.default.createElement(
            _Slider.Slider,
            { loop: false, selected: 0, showArrows: true, showNav: true },
            AccountsList.map(function (account) {
              var symbol = account.currency.toUpperCase();
              var amount = account.amount;

              // Костыль. По хорошему, нужно получать весь список иконок из api

              var symbolToIconMap = {
                RUB: {
                  icon: 'fas fa-ruble-sign',
                  icon_after_value: true
                },
                UAH: {
                  icon: 'fas fa-hryvnia',
                  icon_after_value: true
                },
                KZT: {
                  icon: 'fas fa-tenge',
                  icon_after_value: true
                },
                EUR: {
                  icon: 'fas fa-euro-sign',
                  icon_after_value: false
                },
                USD: {
                  icon: 'fas fa-dollar-sign',
                  icon_after_value: false
                },
                GBP: {
                  icon: 'fas fa-pound-sign',
                  icon_after_value: false
                },
                MDL: {
                  icon: 'L',
                  icon_after_value: false
                },
                BYN: {
                  icon: 'Br',
                  icon_after_value: false
                },
                TRY: {
                  icon: '₺',
                  icon_after_value: false
                },
                AED: {
                  icon: 'Dh',
                  icon_after_value: false
                },
                SGD: {
                  icon: 'S$',
                  icon_after_value: false
                },
                UZS: {
                  icon: 'сўм',
                  icon_after_value: false
                }
              };

              return symbolToIconMap[symbol] ? _react3.default.createElement(
                'div',
                { className: 'one_slider', style: { backgroundColor: '#fff' }, key: symbol },
                _react3.default.createElement(_components2.MoneyValue, {
                  value: amount,
                  icon: symbolToIconMap[symbol].icon,
                  iconAfterValue: symbolToIconMap[symbol].icon_after_value
                })
              ) : _react3.default.createElement(
                'div',
                { className: 'one_slider', style: { backgroundColor: '#fff' }, key: symbol },
                amount
              );
            })
          )
        )
      );
    }
  }, {
    key: 'renderUserProfileFields',
    value: function renderUserProfileFields() {
      var _this2 = this;

      var _props2 = this.props,
          lang = _props2.lang,
          setting = _props2.setting,
          profile = _props2.profile,
          user = _props2.user;
      var additionalFieldSettings = setting.additionalFieldSettings;


      if (!Array.isArray(additionalFieldSettings) || additionalFieldSettings.length === 0) {
        return null;
      }

      return additionalFieldSettings.map(function (field, i) {
        var typeAdditionalField = field.typeAdditionalField,
            show_in_profile = field.show_in_profile;

        var slug = typeAdditionalField.slug === 'username' ? 'name' : typeAdditionalField.slug;
        var currentValue = '';

        if (!show_in_profile) {
          return null;
        }

        if (slug === 'ul_name' || slug === 'inn') {
          currentValue = user.confirmed[slug];
        } else {
          currentValue = user[slug];
        }

        return _react3.default.createElement(_UserProfile.UserInfoRowItem, {
          currentValue: currentValue,
          description: typeAdditionalField.description,
          disabled: profile['disabled_' + slug],
          id: slug,
          key: 'UserInfoRowItem-' + i,
          label: typeAdditionalField.lang_data,
          lang: lang,
          onClickAccept: function onClickAccept() {
            return _this2.props.acceptValue(slug);
          },
          onClickCancel: function onClickCancel() {
            return _this2.props.resetField(slug);
          },
          onClickChange: function onClickChange() {
            return _this2.props.activeField(slug);
          },
          onClickConfirm_email: _this2.props.confirmMail,
          onClickConfirm_phone: _this2.props.confirmPhone,
          user: user,
          validate: profile.validate,
          value: profile[slug],
          onChange: function onChange(e) {
            return _this2.props.changeField({
              name: slug,
              value: e.target.value
            });
          }
        });
      });
    }
  }]);
  return UserInfoView;
}(_react2.Component), _class.propTypes = {
  acceptValue: _react2.PropTypes.func.isRequired,
  activeField: _react2.PropTypes.func.isRequired,
  changeField: _react2.PropTypes.func.isRequired,
  changePassword: _react2.PropTypes.func.isRequired,
  confirmMail: _react2.PropTypes.func.isRequired,
  confirmPhone: _react2.PropTypes.func.isRequired,
  lang: _react2.PropTypes.object.isRequired,
  profile: _react2.PropTypes.object.isRequired,
  resetField: _react2.PropTypes.func.isRequired,
  setting: _react2.PropTypes.object.isRequired,
  user: _react2.PropTypes.object,
  currency: _react2.PropTypes.object.isRequired
}, _class.defaultProps = {
  user: {
    confirmed: {}
  }
}, _temp));

exports.default = UserInfoView;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/UserProfile/UserInfo/default/UserInfoView.jsx
// module id = 1777
// module chunks = 0